
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.706 9.97h-2.27v8.092H8.072V9.97H6.473V7.11h1.6v-1.85c0-1.324.629-3.394 3.394-3.394l2.493.01v2.775h-1.81c-.294 0-.713.147-.713.78v1.68H14l-.294 2.859Z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.706 9.97h-2.27v8.092H8.072V9.97H6.473V7.11h1.6v-1.85c0-1.324.629-3.394 3.394-3.394l2.493.01v2.775h-1.81c-.294 0-.713.147-.713.78v1.68H14l-.294 2.859Z","fill":"#fff"}})])
          )
        }
      }
    